
import { SearchOutlined } from '@ant-design/icons-vue'
import { defineComponent, computed, onMounted } from 'vue'
import { useStore } from 'vuex'

export default defineComponent({
  name: 'SearchBar',
  components: {
    SearchOutlined
  },
  emits: ['update:value'],
  props: {
    value: String,
    onSearch: Function,
    onChange: {
      type: Function,
      default: () => {
        return null
      }
    }
  },
  setup (props, { emit }) {
    const store = useStore()
    const searchStr = computed({
      get: () => props.value,
      set: val => {
        emit('update:value', val)
      }
    })
    const handleSearch = () => {
      props.onSearch()
    }
    const handleChange = () => {
      props.onChange()
    }
    return {
      store,
      searchStr,
      handleSearch,
      handleChange
    }
  }
})
